import i18n from "@/lib/i18n";
import type en from "@/locales/en";

export class ApiError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

type ErrorCode = keyof typeof en.errors;

/**
 * Backend @ExceptionHandler methods return a stable error code (e.g. "INVALID_CREDENTIALS"), never
 * a free-form message — this maps that code to a translated, user-safe string. Any code without a
 * matching translation (including raw framework/500 error bodies we never explicitly mapped) falls
 * back to the generic message instead of leaking server-internal text to the user.
 */
export function extractMessage(e: unknown): string {
  if (e instanceof ApiError && i18n.exists(`errors.${e.message}`)) {
    return i18n.t(`errors.${e.message as ErrorCode}`);
  }
  return i18n.t("common.genericError");
}
